import React, { Component, Fragment } from 'react';
import Loading from '../shared/Loading';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import uberLogoRounded from '../../images/uberLogoRounded.png';
import ReconnectUber from './ReconnectUber';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-solid-svg-icons';

import _ from 'lodash';

const query = gql`
  query getPlatforms {
    getRidesharePlatforms {
      name
      status
      email
      password
    }
  }
`;

class ConnectedAccounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false
    };
  }

  getStatusColor = status => {
    switch (status) {
      case 'signed_up':
      case 'operating':
        return '#128DFF';
      case 'subscribed':
        return '#767676';
      case 'negative_balance':
        return '#FF0000';
      case 'closed':
        return '#767676';
      case 'pending_verification':
        return '#FFB100';
      case 'expired':
        return '#FF0000';
      case 'active':
        return '#3DC700';
      case '':
        return '#FF0000';
      default:
        return '#767676';
    }
  };

  openModal = open => {
    this.setState({ modalOpen: open });
  };

  processStatus = status =>
    status
      ? status === 'blacklisted'
        ? 'suspended'
        : status.split('_').join(' ')
      : 'expired';

  render() {
    const { status, connected_uber_email, username } = this.props;
    const { modalOpen } = this.state;
    return (
      <Query query={query}>
        {({ loading, error, data, refetch }) => {
          if (loading) {
            return <Loading size="3x" />;
          } else if (error) {
            console.log(error);
            return null;
          }

          const rideshareData = data.getRidesharePlatforms;

          const rideshare = _.filter(rideshareData, platform => {
            return platform.name === 'uber';
          });
          const rideshareEmail = rideshareData.length > 0 ? rideshare[0].email : "";
          const ridesharePassword = rideshareData.length > 0 ? rideshare[0].password : "";
          const rideshareStatus = rideshareData.length > 0 ? rideshare[0].status : "";

          console.log(rideshareData);

          return (
            <Fragment>
              <div className="connect__edit">
                <div className="connect__body">
                  <img
                    src={uberLogoRounded}
                    className="connect__body__img"
                    alt="uber logo"
                  />

                  <div className="connect__body__content">
                    <div className="connect__body__content__uber">
                      Uber
                    </div>
                    <div className="">Account Linked</div>
                    <div className="">
                      Status:{' '}
                      <span
                        className="connect__body__content__status"
                        style={{
                          color: `${this.getStatusColor(rideshareStatus)}`
                        }}>
                        {this.processStatus(rideshareStatus)}
                      </span>
                    </div>
                  </div>
                </div>
                {['', 'expired', 'active'].includes(rideshareStatus) ? <div
                  className="icon-box"
                  onClick={() => {
                    this.openModal(true);
                  }}>
                  <FontAwesomeIcon icon={faPen} color="#128DFF" />
                  <div className="edit-label">Edit</div>
                </div> : null}
              </div>

              <ReconnectUber
                rideshare={rideshare}
                status={rideshareStatus}
                connected_uber_email={connected_uber_email}
                platform={'uber'}
                openModal={this.openModal}
                modalOpen={modalOpen}
                rideshareEmail={rideshareEmail}
                ridesharePassword={ridesharePassword}
                refetch={refetch}
              />
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

export default ConnectedAccounts;



// WEBPACK FOOTER //
// ./src/components/Connect/ConnectedAccounts.js